import { render } from "./remove_follower_button.vue?vue&type=template&id=bc80064a"
import script from "./remove_follower_button.js?vue&type=script&lang=js"
export * from "./remove_follower_button.js?vue&type=script&lang=js"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__